import Backend from "shared/lib/Backend";
import { v4 as uuid } from 'uuid';

export default entity => async dispatch => {
  dispatch({
    type: "COLLECTIONS/ENTITY/UPDATING/START"
  });

  delete entity.data.id;
  delete entity.data.meta;

  const body = JSON.stringify({ entity });
  const response = await Backend.requestJson(
    `${window.location.pathname}/collections`,
    { body },
    "POST"
  );

  dispatch({
    type: "COLLECTIONS/ENTITY/UPDATE",
    payload: { entity: entity }
  });

  if (!entity.id) dispatch({ type: "COLLECTIONS/REQUIRE_RELOAD" });

  dispatch({
    type: "COLLECTIONS/ENTITY/UPDATING/FINISH"
  });
};
